import { mapKeys, camelCase, kebabCase } from 'lodash-es';

// Converts top-level keys of a given object to camelCase
export function keysToCamelCase(obj) {
  return mapKeys(obj, (_value, key) => camelCase(key));
}

// Converts top-level keys of a given object to kebabCase
export function keysToKebabCase(obj) {
  return mapKeys(obj, (_value, key) => kebabCase(key));
}
